/// <reference path="../../../../../typings/jquery.d.ts"/>


import { User } from '../../../../../../shared/models/api/User/User';
import { ViewConfiguration } from '../../../../../../shared/services/BasicViewService';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { BasicValidationService } from '../../../../../../shared/services/BasicValidationService';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { AppUtils } from '../../../../../../shared/utils/index';

import { ApplicationPages } from '../../../Constants';
import { ConfirmationPageController } from './ConfirmationPageController';
import { BasicApplicationService } from '../../../../../../shared/services/BasicApplicationService';

export class InputPageController implements StepController, StandardViewEvents {
	private readonly $ctx: JQuery;
	private readonly options: BasicAppOptions<LocalAppDefinition>;
	private readonly parent: AppController;
	private readonly loader: BasicLoader<LocalAppDefinition>;
	private readonly user: User;
	private readonly appViewService: AppViewService;
	private readonly appApplicationService: BasicApplicationService<LocalAppDefinition>;
	private readonly applicationRouter: BasicApplicationRouter<LocalAppDefinition>;
	private readonly appPersistenceService: AppPersistenceService;
	private appValidationService: BasicValidationService<LocalAppDefinition>;

	constructor(parent: AppController, options: BasicAppOptions<LocalAppDefinition>, loader: BasicLoader<LocalAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.$ctx = $(options.$ctx);
		this.user = user;

		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
		this.appApplicationService = new BasicApplicationService(this.options);
		this.applicationRouter = new BasicApplicationRouter(this.options);
	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig: ViewConfiguration<LocalAppDefinition> = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		} else {
			this.applicationRouter.back();
		}
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.appValidationService = new BasicValidationService({ options: this.options }, this.appViewService.getForm());
			this.parent.afterRenderApp();
			this.appViewService.addListeners(this);
			AppUtils.View.stopLoader();
			AppUtils.View.scrollTop();
		});
	}

	private getViewOptions(): { [key: string]: any } {
		return {
			User: this.user
		};
	}

	private checkPreconditions(): boolean {
		return this.user.Verified && !this.user.UserData.Mitgliedschaft.Firma;
	}

	public viewChangeListener(_event: JQuery.Event): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel = this.appViewService.getFormModelFromView();
			this.appPersistenceService.setFormModelToStore(formModel);
		}, 'background');
	}

	public submitListener(event: JQuery.Event): void {
		event.preventDefault();

		if (this.appValidationService.isValid()) {
			AppUtils.View.startLoader();
			const options = this.appApplicationService.preparePageOptions(ApplicationPages.ConfirmationPage);
			const stepController = new ConfirmationPageController(this.parent, options, this.loader, this.user);
			stepController.start();
			AppUtils.View.stopLoader();
		}
	}
}